export const DEFAULT_LOCALE = 'en'

export * from './TranslationUtils'

export { englishMessages } from './messages'
export { translate } from './translate'
export { TranslationProvider } from './TranslationProvider'



// WEBPACK FOOTER //
// ./i18n/index.js